import template from './hirek-kereso.pug';
import hirekServiceModule from '../hirek-service';
import duScroll from 'angular-scroll';
import 'matchmedia-ng';
import getUrlParams from '../../../common/getallurlparams/getallurlparams';
const MODULE_NAME = 'hirekKereso';
const DESKTOP_PAGE_SIZE = 10;
const MOBILE_PAGE_SIZE = 5;
class HirekKeresoController {
	constructor(hirekService, $scope, matchmedia, $document) {
		'ngInject';
		this._hirekService = hirekService;
		this._$scope = $scope;
		this._matchmedia = matchmedia;
		this._$document = $document;
	}
	$onInit() {
		this.currentPage = getUrlParams().page || 1;
		this._cimkekSzama = 10;
		this.model = {};
		this._getKategoriak();
		this._getCimkek();
		this._matchmedia.onPhone((mediaQueryList) => {
			if (mediaQueryList.matches) {
				this.pageFilter = {
					size: MOBILE_PAGE_SIZE,
					page: this.currentPage - 1
				};
			} else {
				this.pageFilter = {
					size: DESKTOP_PAGE_SIZE,
					page: this.currentPage - 1
				};
			}
			if (getUrlParams().cimke) {
				this.cimkeKereses(getUrlParams().cimke);
			} else {
				this._searchType = 'hirekOsszes';
				this.lista({});
			}

		});

	}
	_getCimkek() {
		this._hirekService.getCimkek(this._cimkekSzama).then((response) => {
			this.cimkek = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
	_getKategoriak() {
		this._hirekService.getKategoriak().then((response) => {
			this.kategoriak = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
	getPageHref(page) {
		return `${location.protocol}//${location.host}${location.pathname}?page=${page}`;
	}
	lapozas() {
		this.pageFilter.page = this.currentPage - 1;
		this.lista();
		var topAnchor = angular.element(document.getElementById('topanchor'));
		this._$document.scrollToElementAnimated(topAnchor);
	}
	cimkeKereses(cimke) {
		this.pageFilter.page = 0;
		this._searchType = 'hirekCimkeSzovegAlapjan';
		this.lista({ cimkeSzoveg: cimke });
	}
	kategoriaKereses() {
		this.pageFilter.page = 0;
		this._searchType = 'hirekKategoraAlapjan';
		this.lista({ kategoria: this.model.kategoria.name });
	}
	kategoriaKivalasztas() {
		if (this.model.kategoria) {
			this.kategoriaKereses();
		} else {
			this._searchType = 'hirekOsszes';
			this.lista({});
		}
	}
	szovegKereses(e) {
		e.preventDefault();
		this.pageFilter.page = 0;
		this._searchType = 'hirekSzovegAlapjan';
		this.lista({ szoveg: this.model.kifejezes });
	}
	lista(filter) {
		filter = angular.extend((filter || this.filter), this.pageFilter);
		this._hirekService.lista(filter, this._searchType).then((response) => {
			this.hirek = angular.copy(response[1]);
			this.numFound = response[0].page.totalElements;
			this.filter = filter;
		}, () => {
			this.technikaiHiba = true;
		});
	}
}

export default angular.module(MODULE_NAME, [hirekServiceModule, 'matchmedia-ng', duScroll])
	.component('hirekKereso', {
		controller: HirekKeresoController,
		template: template(),
		bindings: {
			reszletesUrl: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/hirek/hirek-kereso/hirek-kereso.js